import { Center } from "@chakra-ui/react";

export function NotFound() {
  return (
    <Center h="50vh" fontWeight="bold" textAlign="center" color="red.500">
      Page not found.
    </Center>
  );
}
